import { QueryClient } from '@tanstack/react-query';

// Single QueryClient for the SPA — Phase 05 Plan 03 (ARCH-06, Pitfall 14).
// staleTime 30s prevents StrictMode double-mount from doubling network requests; per-query
// `refetchInterval` is opted-in by the job-status hook landed in Phase 07.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
